import { getWindow } from "@faire/web/common/globals/getWindow";

// FIXME(explicitAny) Please remove any and use an appropriate type here. See more: https://faire.link/ban-typescript-any
/* eslint-disable @typescript-eslint/no-explicit-any */

declare const InstallTrigger: unknown;
declare const safari: any;

/**
 * @deprecated -- not compatible with SSR
 */
export const isSafari = () => {
  // https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769
  const userAgentString = getWindow()?.navigator.userAgent.toLowerCase();
  return (
    (/constructor/i.test((getWindow() as any).HTMLElement) ||
      ((p: any) => p.toString() === "[object SafariRemoteNotification]")(
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        !getWindow()["safari"] ||
          (typeof safari !== "undefined" && safari.pushNotification)
      ) ||
      userAgentString?.includes("safari")) &&
    !isChrome()
  );
};

/**
 * @deprecated -- not compatible with SSR
 */
const isChrome = () => {
  const userAgentString = getWindow()?.navigator.userAgent.toLowerCase();
  return (
    (!!(getWindow() as any).chrome &&
      (!!(getWindow() as any).chrome.webstore ||
        !!(getWindow() as any).chrome.runtime)) ||
    userAgentString?.includes("chrome") ||
    userAgentString?.includes("crios")
  );
};
